import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { SiteHeader } from './SiteHeader';
import { SectionPager } from './SectionPager';
import { SiteFooter } from './SiteFooter';
export function Layout() {
  const {
    pathname
  } = useLocation();
  const reduce = useReducedMotion();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-35" data-mp="7904a1y96368">
      <SiteHeader data-id="element-36" data-mp="2aov7tfs7wp2" />
      <main className="pt-16 lg:pt-28" data-id="element-37" data-mp="2b72dl3zfvbr">
        <motion.div key={pathname} initial={reduce ? false : {
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-38" data-mp="gyjs7m0ton7y">
          <Outlet data-id="element-39" data-mp="3kn3ioz5p0tcl" />
        </motion.div>
      </main>
      <SectionPager data-id="element-40" data-mp="3klsgh3rwbtnl" />
      <SiteFooter data-id="element-41" data-mp="3klaavgjcg330" />
    </div>;
}